'use es6';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TrackNavigator from '../../../components/Navigator/TrackNavigator/TrackNavigator';
import { getContentById } from '../../../selectors/contentSelectors';
import { getLessonsForTrack, getTrack } from '../../../selectors/trackSelectors';
import { TRACK_INTRO_URL_FRAGMENT, TRACK_EXAM_URL_FRAGMENT, TRACK_COMPLETE_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT } from '../../../constants/Navigation';
function mapStateToProps(state, ownProps) {
  const {
    match: {
      params: {
        trackId,
        lessonId,
        contentId
      } = {}
    }
  } = ownProps;
  const track = getTrack(state, {
    trackId
  });
  if (!track) {
    return {};
  }
  const currentContentId = [TRACK_INTRO_URL_FRAGMENT, TRACK_EXAM_URL_FRAGMENT, TRACK_COMPLETE_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT].includes(lessonId) ? lessonId : contentId;
  return {
    trackIntroductionVideo: getContentById(state, track.get('introVideo')),
    lessons: getLessonsForTrack(state, {
      trackId
    }),
    exam: getContentById(state, track.get('examId')),
    currentContentId,
    track
  };
}
export const ConnectedTrackNavigator = connect(mapStateToProps)(TrackNavigator);
const TrackNavigatorContainer = withRouter(ConnectedTrackNavigator);
export default TrackNavigatorContainer;